import { withBemMod } from '@bem-react/core';
import { cnIcon } from '@yandex-lego/components/Icon';
import './Icon_type_info.css';
/**
 * Модификатор, отвечающий за тип иконки.
 */
export var withTypeInfo = withBemMod(cnIcon(), { type: 'info' });
